import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { INPUT, LABEL } from './ui';

let cache = null;

// Which bank, cash or gateway account money went through, plus cheque
// details. Hidden when banking isn't available to this user (the default
// account is used then).
export default function BankAccountFields({ meta, setMeta, idPrefix = 'bk' }) {
  const [accounts, setAccounts] = useState(cache || []);

  useEffect(() => {
    if (cache) return;
    api.get('/crm/banking/accounts')
      .then((res) => { cache = (res.data.accounts || []).filter((a) => a.isActive && a.kind !== 'gateway'); setAccounts(cache); })
      .catch(() => setAccounts([]));
  }, []);

  return (
    <>
      {accounts.length > 1 && (
        <div>
          <label className={LABEL} htmlFor={`${idPrefix}-acct`}>Bank / cash account</label>
          <select id={`${idPrefix}-acct`} className={INPUT} value={meta.bankAccountId || ''} onChange={(e) => setMeta({ ...meta, bankAccountId: e.target.value })}>
            {accounts.map((a) => <option key={a._id} value={a.isDefault ? '' : a._id}>{a.name}{a.isDefault ? ' (default)' : ''}</option>)}
          </select>
        </div>
      )}
      {meta.method === 'cheque' && (
        <>
          <div><label className={LABEL} htmlFor={`${idPrefix}-chq`}>Cheque number</label><input id={`${idPrefix}-chq`} className={INPUT} value={meta.chequeNumber || ''} onChange={(e) => setMeta({ ...meta, chequeNumber: e.target.value })} /></div>
          <div><label className={LABEL} htmlFor={`${idPrefix}-chqd`}>Cheque date</label><input id={`${idPrefix}-chqd`} type="date" className={INPUT} value={meta.chequeDate || ''} onChange={(e) => setMeta({ ...meta, chequeDate: e.target.value })} /></div>
        </>
      )}
    </>
  );
}

// Banking page calls this after adding or changing accounts.
export function resetBankAccountCache() { cache = null; }
